import {
  QUERY_KEY_MANAGEMENT_GET_TASK_QUEUE,
  QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE,
  QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_COUNT,
  QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_INFINITE
} from '@apps-common/apis/management/unit-task/task-queue'
import { useManagementCancelUnitTaskQueue } from '@apps-common/apis/management/unit-task/task-queue/cancel-unit-task-queue'
import { useManagementDeleteUnitTaskQueue } from '@apps-common/apis/management/unit-task/task-queue/delete-unit-task-queue'
import { TaskQueueDetailsModal } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/modals'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { ConfirmModal, ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_TASK_QUEUE_STATUS_CANCELLABLE_STATUSES, UNIT_TASK_QUEUE_STATUS_DELETABLE_STATUSES } from '@apps-common/config/unit-task'
import { queryClient } from '@apps-common/lib'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

interface IProps {
  model: IUnitTaskQueueModel
}
export const TasksQueueOptions: React.FC<IProps> = ({ model }) => {
  const { id, status } = model

  const onSuccess = (data?: IUnitTaskQueueModel) => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_GET_TASK_QUEUE(data?.id) })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_COUNT() })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE() })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_INFINITE() })
  }

  const { mutate: cancelItem, isPending: cancelIsPending } = useManagementCancelUnitTaskQueue(true, (data) => onSuccess(data))
  const { mutate: deleteItem, isPending: deleteIsPending } = useManagementDeleteUnitTaskQueue(true, () => onSuccess())

  const updating = cancelIsPending || deleteIsPending

  return (
    <div className='flex items-center justify-end gap-[7px]'>
      {UNIT_TASK_QUEUE_STATUS_DELETABLE_STATUSES.includes(status || '') && (
        <ModalButton
          component={ConfirmModal}
          disabled={updating}
          classes=''
          componentProps={{
            text: 'Delete',
            description: 'Confirm you would like to delete this item in the queue?',
            action: 'error'
          }}
          confirmCallback={() => deleteItem({ model })}
          tooltip={{ id: `job-queue-item-error-modal-${id}`, message: 'Error' }}
        >
          <ButtonRoundSm type='div' className='action-error'>
            <commonIcons.delete />
          </ButtonRoundSm>
        </ModalButton>
      )}
      {UNIT_TASK_QUEUE_STATUS_CANCELLABLE_STATUSES.includes(status || '') && (
        <ModalButton
          component={ConfirmModal}
          disabled={updating}
          classes=''
          componentProps={{
            text: 'Cancel',
            description: 'Confirm you would like to cancel this item in the queue?',
            action: 'warning'
          }}
          confirmCallback={() => cancelItem({ model })}
          tooltip={{ id: `job-queue-item-cancel-modal-${id}`, message: 'Cancel' }}
        >
          <ButtonRoundSm type='div' className='action-warning'>
            <commonIcons.cancel />
          </ButtonRoundSm>
        </ModalButton>
      )}
      <div className='grow inline-block md:hidden'>
        <ModalButton
          component={TaskQueueDetailsModal}
          disabled={false}
          classes='w-full'
          componentProps={{
            id
          }}
          enterAnimation={modalSlideUpEnterAnimation}
          leaveAnimation={modalSlideUpLeaveAnimation}
          tooltip={{ id: `job-queue-item-details-${id}`, message: 'Details' }}
        >
          <ButtonRoundSm
            type='div'
            className='action-brand ring-1 grow flex items-center justify-between gap-[5px] jost-light text-[0.8rem] !pl-[15px] !p-[5px] !pr-[2px] h-[30px] w-full rounded-full'
          >
            Details
            <div className='bg-brand text-on-brand w-[26px] h-[26px] rounded-[13px] flex items-center justify-center'>
              <commonIcons.arrowAngled className='text-[0.9rem]' />
            </div>
          </ButtonRoundSm>
        </ModalButton>
      </div>
      <ModalButton
        component={TaskQueueDetailsModal}
        disabled={false}
        classes='hidden md:inline-block'
        componentProps={{
          id
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
        tooltip={{ id: `job-queue-item-details-${id}`, message: 'Details' }}
      >
        <ButtonRoundSm type='div' className='action-brand-solid'>
          <commonIcons.arrowAngled />
        </ButtonRoundSm>
      </ModalButton>
    </div>
  )
}
